import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import AccountLayout from 'layout/Account';

const CreateUserPage = Loadable(lazy(() => import('pages/user/CreateUser')));

const UserRoutes = {
  path: '/user',
  element: <AccountLayout />,
  children: [
    {
      path: 'add',
      element: <CreateUserPage />
    }
  ]
};

export default UserRoutes;
